import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../utils';

export const PromoCodeApi = createAsyncThunk(
  'PromoCodeApi',
  async (promoCodePayload, { dispatch }) => {
    const { customerRefNum, loanAmount, customerId, Authorization } =
      promoCodePayload;
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'loanbooking3/promocodedata',
      payload: {
        loanAmount,
        customerRefNum,
        appId: APP_ID,
        appVersion: APP_VERSION,
      },
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const promoRes = res;
        dispatch({
          type: 'PromoCodeApi/fulfilled',
          payload: promoRes,
        });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'PromoCodeApi/rejected', payload: err });
      },
    });
  }
);

export const PromoCodeApi_extrareducer = {
  [PromoCodeApi.pending]: (state, action) => {
    state.promoCodeApiState.isLoading = true;
  },
  [PromoCodeApi.fulfilled]: (state, action) => {
    state.promoCodeApiState.isLoading = false;
    state.promoCodeApiState.isSuccess = true;
    state.promoCodeApiState.isError = false;
    state.promoCodeApiState.response = action.payload;
  },
  [PromoCodeApi.rejected]: (state, action) => {
    state.promoCodeApiState.isLoading = false;
    state.promoCodeApiState.isSuccess = false;
    state.promoCodeApiState.isError = true;
    state.promoCodeApiState.response = action.payload;
  },
};
